var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#fff;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil_1_",
    transform: "translate(4716.75 359.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    className: "st0",
    d: "M-4703.2-356.1l-12.1,12.1c-0.1,0.1-0.1,0.1-0.1,0.2l-1.3,5.4c-0.1,0.3,0.1,0.5,0.3,0.6 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l5.4-1.3c0.1,0,0.2-0.1,0.2-0.1l12.1-12.1L-4703.2-356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    className: "st0",
    d: "M-4695.5-357.7l-1.3-1.3c-0.9-0.9-2.4-0.9-3.4,0l-1.7,1.7l4.7,4.7l1.7-1.7 C-4694.5-355.3-4694.5-356.8-4695.5-357.7L-4695.5-357.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/edit-icon-white.eacb5fb9cb7f151a402c3679a568baee.svg";
export { ForwardRef as ReactComponent };